import React, { memo } from "react";
import { FormattedMessage } from "gatsby-plugin-intl";
import PageSection from "components/PageSection";
import { SERVICES_LIST } from "shared/constants/services";
import { useServiceModalsContext } from "components/ServicesModals/context";
import _isEqual from "lodash.isequal";
import ServiceCard from "./ServiceCard";
import "./services.scss";

const Services = () => {
  const servicesModal = useServiceModalsContext();

  const handleServiceClick = (service, event) => {
    if (service.triggersModal) {
      event.preventDefault();
      servicesModal.openModal(service.key);
    }
  };

  return (
    <PageSection
      id="services"
      className="services-wrapper py-20 bg-gray-100"
      pattern={null}
    >
      <div className="container">
        <h3 className="text-black text-p-title font-semibold mb-16 text-center">
          <FormattedMessage id="services.title" />
        </h3>
        <div className="flex justify-center md:justify-between flex-wrap">
          {SERVICES_LIST.map(service => (
            <ServiceCard
              key={service.key}
              title={service.title}
              description={service.description}
              btnText={service.btnText}
              animationSrc={service.animationSrc}
              path={service.path}
              onButtonClick={e => handleServiceClick(service, e)}
            />
          ))}
        </div>
      </div>
    </PageSection>
  );
};

export default memo(Services, _isEqual);
